import { useEffect, useMemo, useState } from 'react';
import { Box, Chip, Typography } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { post } from 'api';
import moment from 'moment';
import { enqueueSnackbar } from 'notistack';
import ApplyLeaveModal from 'components/SS/applyLeaveModel';
import DataGridPagination from 'components/pagination/DataGridPagination';

const MyCorrection = () => {
  const [leaves, setLeaves] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 10,
    page: 0,
    search: '',
  });
  const [open, setOpen] = useState(false);
  const [edit, setEdit] = useState(null);

  const fetchLeaves = async () => {
    setLoading(true);
    try {
      const res = await post('/users/getCorrections', {
        page: paginationModel.page + 1,
        limit: paginationModel.pageSize,
        search: '',
      });
      if (res.status == 200) {
        setLeaves(res.data.data);
        setTotal(res.data.total);
      } else {
        enqueueSnackbar(res.message || 'Error While Fetching Data', {
          variant: 'error',
          autoHideDuration: 3000,
        });
      }
    } catch (error) {
      enqueueSnackbar(error.message || 'Error While Fetching Data', {
        variant: 'error',
        autoHideDuration: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLeaves();
  }, [paginationModel]);

  const columns = useMemo(
    () => [
      // {
      //   field: 'action',
      //   headerName: 'Action',
      //   sortable: false,
      //   filterable: false,
      //   minWidth: 90,
      //   renderCell: (params) => {
      //     return (
      //       <>
      //         {/* <ViewButton row={params.row} /> */}

      //         {params.row.status === 'PENDING' && <EditButton row={params.row} />}
      //       </>
      //     );
      //   },
      // },
      {
        field: 'date',
        headerName: 'Date',
        minWidth: 120,
        sortable: false,
        filterable: false,
        renderCell: (params) => (
          <Typography variant="subtitle2">
            {moment(params.row.date).format('DD/MM/YYYY')}
          </Typography>
        ),
      },
      {
        field: 'attendanceId',
        headerName: 'Attendance Time',
        minWidth: 200,
        sortable: false,
        filterable: false,
        renderCell: (params) => (
          <Typography variant="subtitle2">
            {`${moment(params.row.attendanceId.loginTime).format('HH : mm A')}- ${moment(params.row.attendanceId.logoutTime).format('HH : mm A')}`}
          </Typography>
        ),
      },
      {
        field: 'requestedLogin',
        headerName: 'Requested Time',
        minWidth: 200,
        sortable: false,
        filterable: false,
        renderCell: (params) => (
          <Typography variant="subtitle2">
            {`${moment(params.row.requestedLogin).format('HH : mm A')}- ${moment(params.row.requestedLogout).format('HH : mm A')}`}
          </Typography>
        ),
      },
      {
        field: 'status',
        headerName: 'Status',
        minWidth: 140,
        sortable: false,
        filterable: false,
        renderCell: (params) => {
          const getColor = (status) => {
            switch (status) {
              case 'APPROVED':
                return 'success';
              case 'REJECTED':
                return 'error';
              case 'PENDING':
                return 'warning';
              default:
                return 'default';
            }
          };

          return (
            <Chip
              label={params.row.status}
              color={getColor(params.row.status)}
              size="small"
              sx={{ fontWeight: 500 }}
            />
          );
        },
      },
      {
        field: 'appliedOn',
        headerName: 'Update On',
        minWidth: 190,
        sortable: false,
        filterable: false,
        renderCell: (params) => (
          <Typography variant="subtitle2">
            {moment(params.row.updatedAt).format('DD/MM/YYYY HH:mm')}
          </Typography>
        ),
      },
      {
        field: 'managerId',
        headerName: 'Approved By',
        minWidth: 180,
        sortable: false,
        filterable: false,
        flex: 1,
        renderCell: (params) => {
          const approvedBy = params.row?.managerId;
          return (
            <Typography variant="subtitle2">
              {approvedBy ? `${approvedBy.firstName} ${approvedBy.lastName}` : '-'}
            </Typography>
          );
        },
      },
    ],
    [],
  );

  return (
    <Box p={4}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Typography variant="h5" fontWeight={600} mb={2}>
          My Corrections
        </Typography>
        {/* <Button
          variant="soft"
          shape="square"
          color="neutral"
          sx={{ gap: 0.5, p: 1 }}
          onClick={() => setOpen(true)}
        >
          <IconifyIcon icon="material-symbols:add-2-rounded" />
          Apply Correction
        </Button> */}
      </Box>
      <Box sx={{ width: '100%' }}>
        <DataGrid
          loading={loading}
          rows={leaves}
          columns={columns}
          getRowId={(row) => row._id}
          pagination
          paginationMode="server"
          rowCount={total}
          paginationModel={paginationModel} // { page: 0, pageSize: 10 }
          onPaginationModelChange={(e) => {
            setPaginationModel(() => ({
              page: e.page,
              pageSize: e.pageSize,
              search: '',
            }));
          }}
          pageSizeOptions={[5, 10, 20]}
          slots={{
            basePagination: (props) => <DataGridPagination showFullPagination {...props} />,
          }}
        />
      </Box>
      <ApplyLeaveModal
        open={open}
        edit={edit}
        handleClose={() => {
          setEdit(null);
          setOpen(false);

          fetchLeaves();
        }}
      />
    </Box>
  );
};

export default MyCorrection;
